import { CategoryDefaultValue } from "@containers/dashboard/categories/edit/settings";
import EditGalleryContainer from "@containers/dashboard/gallery/edit";
import { GalleryDefaultValue } from "@containers/dashboard/gallery/edit/settings";
import DashboardLayout from "@layouts/dashboard";
import RoutesInstance from "@routes/instances";
import { useQuery } from "@tanstack/react-query";
import Common from "@utilities/common";
import { useEffect } from "react";
import {
    useLocation,
    useNavigate,
    useParams,
    useSearchParams,
} from "react-router-dom";

const EditGallery = () => {
    const params = useParams();

    const [URLSearchParams] = useSearchParams();

    const { pathname } = useLocation();

    const Navigate = useNavigate();

    const { data, isLoading, refetch } = useQuery(
        ["getGalleryItem"],
        () =>
            Common.api.gallery
                .GetSingle({
                    id: params.id || "",
                })
                .then((res) => res.data),
        {
            enabled: true,
            retry: false,
            onError: () => {
                Navigate(RoutesInstance.gallery);
            },
            onSuccess: () => {
                URLSearchParams.set("refetch", "");

                Navigate(
                    {
                        pathname,
                        search: "?" + URLSearchParams.toString(),
                    },
                    {
                        replace: true,
                    },
                );
            },
        },
    );

    useEffect(() => {
        if (URLSearchParams.get("refetch") === "true") {
            refetch();
        }
    }, [URLSearchParams]);

    return (
        <DashboardLayout title="ویرایش گالری">
            <EditGalleryContainer
                data={data?.result || GalleryDefaultValue}
                loading={isLoading}
            />
        </DashboardLayout>
    );
};

export default EditGallery;
